function initRevealMore(trigger, content, close, mobile) {
    trigger = $(trigger);
    content = $(content);
    close = $(close);
    
    var mobileWindowWidth = 768;
    
    var updateString = function(selector, currentString, updatedString) {
        const origString = currentString;
        
        if ($(selector).text() === currentString) {
            $(selector).text(updatedString);
        } else {
            $(selector).text(origString)
        }
    }
    
    var fadeRevealTansition = function(trigger, content, close) {
        content.hide();
        trigger.on('click', function(){
            content.fadeIn();
        });

        if(close.length) {
            close.on('click', function(){
                content.fadeOut();
            });
        } 
    }
    
    var slideRevealTansition = function(trigger, content) {
        trigger
            .attr({
                'role': 'tab',
                'aria-selected': 'false',
                'aria-expanded': 'false',
            });
        
        content
            .attr({
                'role': 'tabpanel',
                'aria-hidden': 'true',
            })
            .hide();
        
        var currentText = trigger.text();
        
        trigger.on('click', function(e){
            e.preventDefault();
            
            if ($(this).attr( 'aria-expanded') === 'true') {
                $(this).attr( 'aria-expanded', 'false');
            } else {
                $(this).attr( 'aria-expanded', 'true');
            }
            
            if($(this).next(content).length) {
                var expandableContent = $(this).next();
            } else if ($(this).prev(content).length){
                var expandableContent = $(this).prev();
            } else {
                return false;
            }
            
            $(this).toggleClass('is-active');
            
            if (expandableContent) { 
                expandableContent.slideToggle(function(){
                    $(this).parent().toggleClass('is-active');
                });
            }
        }); 
        
        trigger.on('focus', function(){
            $(this).attr({
                'aria-selected': 'true',
            })
        })
        
        trigger.on('blur', function(){
            $(this).attr({
                'aria-selected': 'false',
            })
        })
    }
    
    var toggleRevealTansition = function(trigger, content, close) {
        trigger
            .attr({
                'role': 'tab',
                'aria-selected': 'false',
                'aria-expanded': 'false',
            });
        
        content
            .attr({
                'role': 'tabpanel',
                'aria-hidden': 'true',
            })
        
        trigger.on('click', function(e){
            e.preventDefault();
            $(this).toggleClass('is-active');
            content.toggleClass('is-active');
        }); 

        if(close.length) {
            close.on('click', function(){
                trigger.removeClass('is-active');
                content.removeClass('is-active');
            }); 
        }
    }
    
    var fadeReveal = function(trigger, content, close, mobile) {
        if(mobile === true) {
            if($(window).width() <= mobileWindowWidth) {
                fadeRevealTansition(trigger, content, close);
            } else {
                content.show();
            }
        } else {
            fadeRevealTansition(trigger, content, close);
        }
    };
    
    var toggleReveal = function(trigger, content, close, mobile) {
        if(mobile === true) {
            toggleRevealTansition(trigger, content, close);
        } else {
            toggleRevealTansition(trigger, content, close);
        }
    };
    
    var slideReveal = function(trigger, content, mobile) {
        if(mobile === true) {
            if($(window).width() <= mobileWindowWidth) {
                slideRevealTansition(trigger, content);
            } else {
                content.show();
            }
        } else {
            slideRevealTansition(trigger, content);
        }
    };
    
    var revealType = trigger.data('reveal-type');
    switch (revealType) {
        case 'toggle':
            toggleReveal(trigger, content, close, mobile);
            break;
        case 'fade':
            fadeReveal(trigger, content, close, mobile);
            break;
        case 'slide':
            slideReveal(trigger, content, mobile);
            break;
    };   
}

// Find links without an href that match a phone number pattern and convert to tel links
function applyTelLinks() {
    let links = document.querySelectorAll('a');
    let phonePattern = /^\(?([0-9]{3})\)?[-. \s]?([0-9]{3})[-. \s]?([0-9]{4})$/;

    for (let link of links) {
        if (!link.href) {
            let linkText = link.outerText;
            if (linkText && phonePattern.test(linkText)) {
                linkText = linkText.replace(/[^0-9\+]/g, '');
                link.href = `tel:${linkText}`;
            }
        }
    }
}

function extractNumber(str) {
    let parts = str.split('-');
    return parts.length > 1 ? parseInt(parts.pop(), 10) : null;
}

export default {
    initReveal: initRevealMore,
    applyTelLinks: applyTelLinks,
    extractNumber: extractNumber
}